import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "grid" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", null, "Site Name*", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", null, "Site Protocol Prefix*", -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", null, "Brand*", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("span", null, "Market*", -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", null, "Division* (type the value or chose an existing one)", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", null, "Prio*", -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", null, "Site Type*", -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", null, "Environment Type (type the value or chose an existing one)", -1);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("span", null, "Audience", -1);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("span", null, "Site Framework", -1);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("label", { for: "is_public" }, "Is Public", -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("span", null, "Public Sites ", -1);
const _hoisted_14 = { class: "pi pi-info-circle" };
import { computed, onBeforeMount, ref, watch, } from "vue";
import Checkbox from "primevue/checkbox";
import OneDeskInput from "@/components/atoms/OneDeskInput.vue";
import OneDeskDropdown from "@/components/atoms/OneDeskDropdown.vue";
import { addWebSite, getWebsiteDetails, getPublicWebsitesByBrandAndMarket, updateWebSite, } from "@/repositories/inventory.repository";
import { divisionList, environmentTypeList, priorityList, siteProtocolPrefixesList, siteTypesList, } from "@/shared/utils/website.constant";
import { useStore } from "@/shared/composables/useStore";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
import { mandatoryField, maxLength } from "@/shared/utils/validation";
import { AllActionTypes } from "@/store/action-types";
import useFormValidation from "@/shared/composables/useFormValidation";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UpsertWebSite',
    props: {
        webSiteId: {},
        fullScreen: { type: Boolean }
    },
    emits: ["website-updated"],
    setup(__props, { emit: __emit }) {
        const { validationStateDict, invalidForm } = useFormValidation();
        const notify = useToastNotify();
        const { webSiteId = undefined, fullScreen = false } = __props;
        const store = useStore();
        const selectedWebsite = ref({
            siteName: "",
            siteProtocolPrefix: "",
            audience: "",
            brand: "",
            market: "",
            division: "",
            siteType: "",
            prio: "",
            environmentType: "",
            siteFramework: "",
            isPublic: true,
        });
        const publicSiteId = ref("");
        const publicWebsitesOfBrandAndMarket = ref([]);
        const brands = computed(() => store.getters[ReferenceValuesTypes.BRANDS]);
        const markets = computed(() => store.getters[ReferenceValuesTypes.MARKETS]);
        const siteProtocolPrefixes = siteProtocolPrefixesList;
        const divisions = divisionList;
        const environmentTypes = environmentTypeList;
        const siteTypes = siteTypesList;
        const priorities = priorityList;
        const fullScreenOrSideBar = computed(() => {
            return fullScreen ? "col-12 lg:col-6" : "col-12";
        });
        const emit = __emit;
        onBeforeMount(async () => {
            store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.BRANDS);
            store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.MARKETS);
            if (webSiteId) {
                selectedWebsite.value = { ...(await getWebsiteDetails(webSiteId)) };
                publicSiteId.value = selectedWebsite.value.publicSite?.id;
            }
        });
        watch(() => [selectedWebsite.value.brand, selectedWebsite.value.market], async ([newBrand, newMarket]) => {
            if (!newBrand || !newMarket)
                return;
            publicWebsitesOfBrandAndMarket.value = await getPublicWebsitesByBrandAndMarket(newBrand, newMarket);
        });
        const onSave = async () => {
            if (invalidForm.value)
                notify("", "Please enter the mandatory fields", "warn");
            else {
                try {
                    const website = buildWebsiteInput();
                    if (webSiteId) {
                        const updatedWebSite = {
                            id: webSiteId,
                            ...website,
                        };
                        await updateWebSite(updatedWebSite);
                    }
                    else {
                        await addWebSite(website);
                    }
                    notifyUserAndEmitUpdated(webSiteId ? "updated" : "created");
                }
                catch (error) {
                    notify("", error.message, "warn");
                }
            }
        };
        const notifyUserAndEmitUpdated = (action = "updated") => {
            notify("", `WebSite has been successfully ${action}`, "success");
            emit("website-updated");
        };
        const buildWebsiteInput = () => {
            return {
                siteName: selectedWebsite.value.siteName,
                siteProtocolPrefix: selectedWebsite.value.siteProtocolPrefix,
                audience: selectedWebsite.value.audience,
                brand: selectedWebsite.value.brand,
                market: selectedWebsite.value.market,
                division: selectedWebsite.value.division,
                siteType: selectedWebsite.value.siteType,
                prio: selectedWebsite.value.prio,
                environmentType: selectedWebsite.value.environmentType,
                siteFramework: selectedWebsite.value.siteFramework,
                isPublic: selectedWebsite.value.isPublic,
                publicSiteId: publicSiteId.value,
            };
        };
        return (_ctx, _cache) => {
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    _createVNode(OneDeskInput, {
                        modelValue: selectedWebsite.value.siteName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedWebsite.value.siteName) = $event)),
                        class: "wp-pages-inputs",
                        "max-length": 70,
                        rules: [_unref(mandatoryField), _unref(maxLength)(70)],
                        "onUpdate:valid": _cache[1] || (_cache[1] = ($event) => (_unref(validationStateDict).siteName = $event))
                    }, {
                        label: _withCtx(() => [
                            _hoisted_2
                        ]),
                        _: 1
                    }, 8, ["modelValue", "rules"])
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    _createVNode(OneDeskDropdown, {
                        modelValue: selectedWebsite.value.siteProtocolPrefix,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedWebsite.value.siteProtocolPrefix) = $event)),
                        options: _unref(siteProtocolPrefixes),
                        class: "backoffice-dropdown wp-pages-inputs",
                        lineraLabel: false,
                        optionValue: "value",
                        optionLabel: "value",
                        required: true,
                        "onUpdate:valid": _cache[3] || (_cache[3] = ($event) => (_unref(validationStateDict).siteProtocolPrefix = $event))
                    }, {
                        label: _withCtx(() => [
                            _hoisted_3
                        ]),
                        _: 1
                    }, 8, ["modelValue", "options"])
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    _createVNode(OneDeskDropdown, {
                        modelValue: selectedWebsite.value.brand,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedWebsite.value.brand) = $event)),
                        filter: "",
                        options: brands.value,
                        class: "backoffice-dropdown wp-pages-inputs",
                        lineraLabel: false,
                        optionValue: "id",
                        optionLabel: "label",
                        required: true,
                        "onUpdate:valid": _cache[5] || (_cache[5] = ($event) => (_unref(validationStateDict).brand = $event))
                    }, {
                        label: _withCtx(() => [
                            _hoisted_4
                        ]),
                        _: 1
                    }, 8, ["modelValue", "options"])
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    _createVNode(OneDeskDropdown, {
                        modelValue: selectedWebsite.value.market,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((selectedWebsite.value.market) = $event)),
                        filter: "",
                        options: markets.value,
                        class: "backoffice-dropdown wp-pages-inputs",
                        lineraLabel: false,
                        optionValue: "id",
                        optionLabel: "label",
                        required: true,
                        "onUpdate:valid": _cache[7] || (_cache[7] = ($event) => (_unref(validationStateDict).market = $event))
                    }, {
                        label: _withCtx(() => [
                            _hoisted_5
                        ]),
                        _: 1
                    }, 8, ["modelValue", "options"])
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    _createVNode(OneDeskDropdown, {
                        modelValue: selectedWebsite.value.division,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((selectedWebsite.value.division) = $event)),
                        filter: "",
                        options: _unref(divisions),
                        class: "backoffice-dropdown backoffice-editable-dropdown wp-pages-inputs",
                        lineraLabel: false,
                        optionValue: "value",
                        optionLabel: "value",
                        editable: true,
                        required: true,
                        "onUpdate:valid": _cache[9] || (_cache[9] = ($event) => (_unref(validationStateDict).market = $event))
                    }, {
                        label: _withCtx(() => [
                            _hoisted_6
                        ]),
                        _: 1
                    }, 8, ["modelValue", "options"])
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    _createVNode(OneDeskDropdown, {
                        modelValue: selectedWebsite.value.prio,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((selectedWebsite.value.prio) = $event)),
                        options: _unref(priorities),
                        class: "backoffice-dropdown wp-pages-inputs",
                        lineraLabel: false,
                        optionValue: "value",
                        optionLabel: "displayValue",
                        required: true,
                        "onUpdate:valid": _cache[11] || (_cache[11] = ($event) => (_unref(validationStateDict).prio = $event))
                    }, {
                        label: _withCtx(() => [
                            _hoisted_7
                        ]),
                        _: 1
                    }, 8, ["modelValue", "options"])
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    _createVNode(OneDeskDropdown, {
                        modelValue: selectedWebsite.value.siteType,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((selectedWebsite.value.siteType) = $event)),
                        options: _unref(siteTypes),
                        class: "backoffice-dropdown wp-pages-inputs",
                        lineraLabel: false,
                        optionValue: "value",
                        optionLabel: "value",
                        required: true,
                        "onUpdate:valid": _cache[13] || (_cache[13] = ($event) => (_unref(validationStateDict).siteType = $event))
                    }, {
                        label: _withCtx(() => [
                            _hoisted_8
                        ]),
                        _: 1
                    }, 8, ["modelValue", "options"])
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    _createVNode(OneDeskDropdown, {
                        modelValue: selectedWebsite.value.environmentType,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((selectedWebsite.value.environmentType) = $event)),
                        options: _unref(environmentTypes),
                        class: "backoffice-dropdown backoffice-editable-dropdown wp-pages-inputs",
                        lineraLabel: false,
                        optionValue: "value",
                        optionLabel: "value",
                        editable: true
                    }, {
                        label: _withCtx(() => [
                            _hoisted_9
                        ]),
                        _: 1
                    }, 8, ["modelValue", "options"])
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    _createVNode(OneDeskInput, {
                        modelValue: selectedWebsite.value.audience,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((selectedWebsite.value.audience) = $event)),
                        class: "wp-pages-inputs",
                        "max-length": 10,
                        rules: [_unref(maxLength)(10)],
                        "onUpdate:valid": _cache[16] || (_cache[16] = ($event) => (_unref(validationStateDict).audience = $event))
                    }, {
                        label: _withCtx(() => [
                            _hoisted_10
                        ]),
                        _: 1
                    }, 8, ["modelValue", "rules"])
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    _createVNode(OneDeskInput, {
                        modelValue: selectedWebsite.value.siteFramework,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((selectedWebsite.value.siteFramework) = $event)),
                        class: "wp-pages-inputs",
                        "max-length": 25,
                        rules: [_unref(maxLength)(25)],
                        "onUpdate:valid": _cache[18] || (_cache[18] = ($event) => (_unref(validationStateDict).siteFramework = $event))
                    }, {
                        label: _withCtx(() => [
                            _hoisted_11
                        ]),
                        _: 1
                    }, 8, ["modelValue", "rules"])
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value),
                    style: { "display": "flex", "gap": "10px" }
                }, [
                    _createVNode(_unref(Checkbox), {
                        modelValue: selectedWebsite.value.isPublic,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((selectedWebsite.value.isPublic) = $event)),
                        inputId: "is_public",
                        name: "isPublic",
                        binary: ""
                    }, null, 8, ["modelValue"]),
                    _hoisted_12
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    (!selectedWebsite.value.isPublic)
                        ? (_openBlock(), _createBlock(OneDeskDropdown, {
                            key: 0,
                            filter: "",
                            modelValue: publicSiteId.value,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((publicSiteId).value = $event)),
                            options: publicWebsitesOfBrandAndMarket.value,
                            class: "backoffice-dropdown public-sites-list wp-pages-inputs",
                            lineraLabel: false,
                            optionValue: "id",
                            optionLabel: "label"
                        }, {
                            label: _withCtx(() => [
                                _hoisted_13,
                                _withDirectives(_createElementVNode("i", _hoisted_14, null, 512), [
                                    [_directive_tooltip, 'Please select a brand']
                                ])
                            ]),
                            _: 1
                        }, 8, ["modelValue", "options"]))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(fullScreenOrSideBar.value)
                }, [
                    _createVNode(OneDeskButton, {
                        severity: _unref(invalidForm) ? 'secondary' : 'primary',
                        icon: "pi pi-save",
                        onClick: onSave,
                        disabled: _unref(invalidForm),
                        label: "Save"
                    }, null, 8, ["severity", "disabled"])
                ], 2)
            ]));
        };
    }
});
